import React, { useState, useEffect } from 'react';
import { api } from '@/api/apiClient';
import MaintenanceMode from '@/pages/MaintenanceMode';

// Get API URL from environment variable (same as apiClient)
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export default function MaintenanceCheck({ children }) {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkMaintenance();
  }, []);

  const checkMaintenance = async () => {
    try {
      // First, check maintenance mode status using public endpoint (no auth required)
      const url = `${API_URL}/api/public/maintenance-status`;
      console.log('Checking maintenance at:', url);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });
      
      if (!response.ok) {
        console.error('Maintenance status check failed:', response.status);
        setIsMaintenanceMode(false);
        setLoading(false);
        return;
      }
      
      const maintenanceData = await response.json();
      console.log('Maintenance status:', maintenanceData);
      
      const maintenanceEnabled = maintenanceData.maintenance_mode === true;
      setIsMaintenanceMode(maintenanceEnabled);

      // If maintenance mode is on, check if user is admin
      if (maintenanceEnabled) {
        try {
          const user = await api.auth.me();
          const userIsAdmin = user?.user_role === 'admin';
          console.log('User is admin:', userIsAdmin);
          setIsAdmin(userIsAdmin);
        } catch (err) {
          // User not authenticated, they are not admin
          console.log('User not authenticated');
          setIsAdmin(false);
        }
      }
    } catch (err) {
      console.error('Failed to check maintenance mode:', err);
      // On error, assume no maintenance mode to avoid locking everyone out
      setIsMaintenanceMode(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-slate-200 border-t-slate-800 rounded-full animate-spin"></div>
      </div>
    );
  }

  console.log('Maintenance check render:', { isMaintenanceMode, isAdmin });

  // If maintenance mode is on and user is not admin, show maintenance page
  if (isMaintenanceMode && !isAdmin) {
    console.log('Showing maintenance page');
    return <MaintenanceMode />;
  }

  console.log('Showing normal app');
  // Otherwise, render the app normally
  return children;
}
